import {GET_USER_ACTION, GET_PERMISSION,GET_LIST_SERVICE} from "./actionTypes";


export const getUser = (state) => {
  return {
      type: GET_USER_ACTION,
      payload: state
  };
};

export const getPermission = (state) => {
  return {
      type: GET_PERMISSION,
      payload: state
  };
};

export const getListService = (state) => {
  return {
      type: GET_LIST_SERVICE,
      payload: state
  };
};